// src/experiments/longer-periods.mjs

/**
 * @type {Experiment}
 */
export const LongerPeriodsExperiment = {
  id: 'longer-periods',
  type: 'period',
  name: 'Længere Perioder',
  exclusive: false,
  allowMultiple: false, // 🚨 Tillader eksplicit IKKE at køre flere gange!
  
  /**
   * Initialiserer eksperimentet og injicerer de nye perioder i applikationens state
   * @param {AppState} appState 
   * @returns {void}
   */
  init(appState) {
    console.log('[Eksperiment] Rekonfigurerer PERIODS til længere intervaller...');
    
    // Nye, længere værdier der skal overskrive standarden
    /** @type {readonly (PeriodDuration | null)[]} */
    const longerPeriods = Object.freeze([
        null,
        Object.freeze({ years: 4 }),
        Object.freeze({ years: 5, months: 6 }),
        Object.freeze({ years: 7 }),
        Object.freeze({ years: 9 }),
    ]);
    
    // Injicer værdierne direkte ind i statens konfiguration
    appState.updateConfig('periods', longerPeriods);
  }
};
